module.exports = __webpack_public_path__ + "static/img/icon_pingzi@2x.fa3194b4.png";